// (A) 중립 Badge API — antd 미접촉. (B) PlainBadge 에 위임.
import type { CSSProperties, ReactNode } from 'react'
import { PlainBadge } from '../_impl/PlainBadge'

export interface OmwBadgeProps {
  /** 실측: UserMenu/WorkspaceMenu 가 count 배지 사용. */
  count?: number
  overflowCount?: number
  className?: string
  style?: CSSProperties
  children?: ReactNode
}

export function OmwBadge(props: OmwBadgeProps) {
  return <PlainBadge {...props} />
}
